import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AlertDomainService } from '../../../../domain/services/alert/alert.domain.service';
import { JobDomainService } from '../../../../domain/services/job/job.domain.service';
import { MapsService } from '../../../../maps/services/maps.service';
import { Alert } from '../../../../domain/models/alert';
import { Job } from '../../../../domain/models/job';
import { Polyline } from '../../../../domain/models/polyline';

@Injectable()
export class AlertOverviewService {
    constructor(
        private alertDomainService: AlertDomainService,
        private jobDomainService: JobDomainService,
        private mapsService: MapsService) { }

    getAlertsForJob(jobId: string): Observable<Alert[] | {}> {
        return this.alertDomainService.getAlertsByJob(jobId);
    }

    createAlert(alert: Alert): Observable<any> {
        return this.alertDomainService.createAlert(alert);
    }

    deleteAlert(alertId: string): Observable<any> {
        return this.alertDomainService.deleteAlert(alertId);
    }

    getTimeZoneForJob(jobId: string): Observable<{} | string> {
        return this.jobDomainService.getTimezoneForJob(jobId);
    }

    getRoute(routeId: string): Observable<void | Job> {
        return this.jobDomainService.getJob(routeId);
    }

    drawRoute(polyline: Polyline) {
        this.clearMap();
        this.mapsService.drawPersistedRoute(polyline);
    }

    clearMap() {
        this.mapsService.clearRoute();
        this.mapsService.clearSpectroPolylines();
        this.mapsService.clearMapOverlays(true);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/alert-overview/services/alert-overview.service.ts